import { render, staticRenderFns } from "./GoalsClientForm.vue?vue&type=template&id=e78b8e7e"
import script from "./GoalsClientForm.vue?vue&type=script&lang=js"
export * from "./GoalsClientForm.vue?vue&type=script&lang=js"
import style0 from "./GoalsClientForm.vue?vue&type=style&index=0&id=e78b8e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports